import React from 'react';
import useTranslation from '../hooks/useTranslation';
import XiLogo from './ui/XiLogo';

export default function SubscriptionModal({ open, onClose, userRole, plan, onUpgrade }) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div className="login-modal-bg subscription-modal-bg" style={{ zIndex: 9999 }}>
      <div
        className="login-card subscription-modal-card"
        style={{
          maxWidth: 440,
          width: '92vw',
          boxSizing: 'border-box',
          padding: '2.2rem 1.6rem 1.8rem',
          position: 'relative',
          background: 'var(--color-modal-bg)',
          color: 'var(--color-modal-text)',
          border: '1px solid var(--border-1)',
          borderRadius: 'var(--xi-radius-lg)',
          boxShadow: 'var(--xi-elev-3)',
        }}
      >
        <button
          type="button"
          className="login-close-btn"
          aria-label={t('Close Subscription Modal')}
          onClick={onClose}
          style={{ right: '1rem', left: 'auto', top: '1.2rem', position: 'absolute' }}
        >
          <span style={{ fontFamily: 'Arial, sans-serif', fontWeight: 300, fontSize: '1.5em', lineHeight: 1 }}>×</span>
        </button>

        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0.9rem' }}>
          <XiLogo size="sm" wordmark={false} label="" />
        </div>

        <h1
          style={{
            marginBottom: '0.5rem',
            fontSize: 'clamp(1.35rem, 5vw, 1.85rem)',
            fontWeight: 700,
            color: 'var(--heading-color)',
            letterSpacing: 'var(--xi-tracking-tight)',
            textAlign: 'center',
            wordWrap: 'break-word',
          }}
        >
          {t('Your Subscription Plan')}
        </h1>

        <div
          style={{
            textAlign: 'center',
            color: 'var(--xi-violet)',
            fontWeight: 600,
            fontSize: '1rem',
            marginBottom: 22,
            letterSpacing: '0.02em',
          }}
        >
          {t(userRole)} {t('Plan')}
        </div>

        {plan && (
          <>
            <div
              style={{
                fontWeight: 700,
                fontSize: '1.12rem',
                color: 'var(--heading-color)',
                marginBottom: 4,
              }}
            >
              {t(plan.name)}
            </div>
            <div
              style={{
                fontWeight: 700,
                fontSize: '1.2rem',
                color: 'var(--xi-blue)',
                marginBottom: 10,
              }}
            >
              {t(plan.price)}
              {plan.period ? t(plan.period) : ''}
            </div>
            <ul
              style={{
                margin: '0 0 18px 0',
                padding: 0,
                listStyle: 'disc inside',
                color: 'var(--subheading-color)',
                fontSize: '1.02rem',
                textAlign: 'left',
                lineHeight: 1.55,
              }}
            >
              {plan.features &&
                plan.features.map((f, i) => (
                  <li key={i} style={{ marginBottom: 4 }}>
                    {t(f)}
                  </li>
                ))}
            </ul>
          </>
        )}

        <button
          className="login-btn submit"
          style={{
            background: 'var(--bg-primary)',
            color: 'var(--text-primary)',
            fontWeight: 700,
            minWidth: 120,
            width: '100%',
            marginTop: 8,
            padding: '0.9rem 0',
            fontSize: '1.05rem',
            borderRadius: 'var(--xi-radius-sm)',
            border: 'none',
            cursor: 'pointer',
            transition: 'background var(--xi-dur) var(--xi-ease)',
          }}
          onClick={onUpgrade}
        >
          {t('Upgrade Plan')}
        </button>
      </div>
    </div>
  );
}
